import { useSkuContext } from "@/contexts/skuContext";
import { createSkuSchema } from "@/schemas/sku/create";
import { useSkuFormFields } from "@/hooks/sku/useSkuFormFields";
import { ImageUploadStep, FormFieldsStep } from "../commos/FormStep";

export const FirstStep = () => {
    const { onUpload, onClearFile } = useSkuContext();

    return (
        <ImageUploadStep
            onUpload={onUpload}
            onClearFile={onClearFile}
            fileConfiguration={{
                title: "Carga de imágenes para nuevo SKU",
                description: "Carga el archivo de imagen de SKU",
                maxSizeMB: 2,
            }}
        />
    );
};

export const SecondStep = () => {
    const { onComplete, isFetching, catalogs } = useSkuContext();
    const { fields } = useSkuFormFields({ catalogs });

    return (
        <FormFieldsStep
            schema={createSkuSchema}
            defaultValues={{
                sku_number: "",
                name: "",
                brand: "",
                presentation: "",
                volume: "",
                quantity: "",
                tipology: "",
                size: ""
            }}
            fields={fields as any}
            onComplete={onComplete}
            isFetching={isFetching}
            formId="sku-general-info"
            description="Aquí podrás ingresar la información correspondiente a tu SKU"
            className="px-10 pt-3 pb-6"
        />
    );
};